import { cn } from "@/utils/cn";
import {
  getReadableShiftCodeTextColor,
  getScheduleShiftCodeFontSize,
} from "@/utils/fontSizeUtils";

/** 일자 셀 내부 칩 — 호버는 부모 버튼이 `dayN`으로 처리 (여기서 스토어 호출 시 day 열이 깨짐) */
function ShiftCode({
  code,
  color,
  children,
}: {
  code: string;
  color?: string;
  children?: React.ReactNode;
}) {
  const displayCode = code.trim() === "" || code.trim() === "-" ? "-" : code;
  const isEmptyCode = displayCode === "-";
  const fontSize = getScheduleShiftCodeFontSize(displayCode);
  const textColor = isEmptyCode
    ? "#FFFFFF"
    : getReadableShiftCodeTextColor(color);
  const backgroundColor = isEmptyCode ? "#EEF1F6" : color;
  const borderColor = isEmptyCode ? "#D6DBE4" : undefined;

  return (
    <div data-shift-display={displayCode}>
      <div
        className={cn(
          "relative flex aspect-square w-7 items-center justify-center rounded-[5px] border border-border font-semibold leading-none",
          !color && !isEmptyCode && "bg-muted"
        )}
        style={{ backgroundColor, borderColor, color: textColor, fontSize }}
      >
        <span className="max-w-full whitespace-nowrap leading-none">
          {displayCode}
        </span>
        {children}
      </div>
    </div>
  );
}

export default ShiftCode;
